import { Box, withStyles } from '@material-ui/core';

export const PagesWrapperBox = withStyles(() => ({
  root: {
    maxWidth: 1200,
  },
}))(Box);

export const BlockedWrapperBox = withStyles(({ spacing }) => ({
  root: {
    paddingTop: spacing(10),
    maxWidth: 1200,
    margin: '0 auto',
  },
}))(Box);
